// AUTO-GENERATED GraphQL Builder for BookingSlotSelection
import * as Builders from '../';
export class BookingSlotSelectionBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingId(){ return this.add('bookingId'); }
  serviceCategoryId(){ return this.add('serviceCategoryId'); }
  slotOptionId(){ return this.add('slotOptionId'); }
  amount(){ return this.add('amount'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  serviceCategory(b?:(q:Builders.ServiceCategoryBuilder)=>void){
    if(this.depth>=5||this.v.has('serviceCategory'))return this;
    this.v.add('serviceCategory');
    const n=new Builders.ServiceCategoryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`serviceCategory { ${inner} }`);
    return this;
  }

  slotOption(b?:(q:Builders.SlotOptionBuilder)=>void){
    if(this.depth>=5||this.v.has('slotOption'))return this;
    this.v.add('slotOption');
    const n=new Builders.SlotOptionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`slotOption { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }
}
